import { useApi } from '~/api/index';
import { components, operations } from '~~/api-types';

export type PaginatedBusinessesResponseDto =
  components['schemas']['PaginatedBusinessesResponseDto'];

export type BusinessResponseDto = components['schemas']['BusinessResponseDto'];

export type GetBusinessesListQueryParams =
  operations['GetAuthUserBusinessesEndpoint_getUserBusinesses']['parameters']['query'];

export const selectActiveBusiness = (businessId: string | number) => {
  const api = useApi();

  return api(`/businesses/${businessId}/select`, {
    method: 'POST',
  });
};

export const getBusinessList = (
  params?: GetBusinessesListQueryParams,
): Promise<PaginatedBusinessesResponseDto> => {
  const api = useApi();

  return api('/businesses', {
    method: 'GET',
    params,
  });
};
